/**
 * @generated SignedSource<<9a3a5211e333589bb63124d1c63c13cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SignalWorkspaceTemplateSelectorUpdateTemplatePopupMutation$variables = {
  name?: string | null;
  signalWorkspaceId: string;
  templateId: string;
};
export type SignalWorkspaceTemplateSelectorUpdateTemplatePopupMutation$data = {
  readonly signalWorkspaceTemplate: {
    readonly updateTemplateFromWorkspaceSignal: {
      readonly id: string;
      readonly name: string;
    };
  };
};
export type SignalWorkspaceTemplateSelectorUpdateTemplatePopupMutation = {
  response: SignalWorkspaceTemplateSelectorUpdateTemplatePopupMutation$data;
  variables: SignalWorkspaceTemplateSelectorUpdateTemplatePopupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "signalWorkspaceId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "templateId"
      }
    ],
    "concreteType": "SignalWorkspaceTemplateMutation",
    "kind": "LinkedField",
    "name": "signalWorkspaceTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "signalWorkspaceId"
          },
          {
            "kind": "Variable",
            "name": "setName",
            "variableName": "name"
          }
        ],
        "concreteType": "SignalWorkspaceTemplate",
        "kind": "LinkedField",
        "name": "updateTemplateFromWorkspaceSignal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SignalWorkspaceTemplateSelectorUpdateTemplatePopupMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SignalWorkspaceTemplateSelectorUpdateTemplatePopupMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "16965df96d9fbee7ec0395c162c5d545",
    "id": null,
    "metadata": {},
    "name": "SignalWorkspaceTemplateSelectorUpdateTemplatePopupMutation",
    "operationKind": "mutation",
    "text": "mutation SignalWorkspaceTemplateSelectorUpdateTemplatePopupMutation(\n  $templateId: ID!\n  $signalWorkspaceId: ID!\n  $name: String\n) {\n  signalWorkspaceTemplate(id: $templateId) {\n    updateTemplateFromWorkspaceSignal(id: $signalWorkspaceId, setName: $name) {\n      name\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9375d7d1b40bb27e36206642f5dbc85e";

export default node;
